import { QueryOptions } from 'react-query';
import { getFarmPartners } from './solar-farm-partners.api';
import { PartnerFarmLink } from './solar-farm-partners.schema';

export const FARM_PARTNERS_QUERY_KEY_PREFIX = 'farm-partners';

export const getFarmPartnersQuery = (
  solarFarmId: number,
): QueryOptions<PartnerFarmLink[]> => ({
  queryKey: [FARM_PARTNERS_QUERY_KEY_PREFIX, { solarFarmId }],
  queryFn: () => getFarmPartners(solarFarmId),
});
